const checkoutPageES = {
    activateTitle: "Activa tu negocio",
    activateSubtitle: "Completa tu suscripción para empezar a aceptar reservas.",
    totalSeats: "Asientos totales",
    staffSeats: "Asientos de personal",
    poweredBy: "Pagos seguros gestionados por Paddle",
    stillThere: "¿Sigues ahí?",
    continue: "Continuar",
    shopLive: "¡Felicidades! Tu negocio ya está en vivo y visible al público."

};
export default checkoutPageES